import {GuestFooterGroup} from '../groups';
import {NavigationContext} from '../navigation.context';

export const GuestMenu = (context: NavigationContext) => [
    GuestFooterGroup(context)
];